import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Brand from "@/pages/brand/page";
import Products from "@/pages/products/page";
import ProductDetail from "@/pages/products/detail/page";
import Projects from "@/pages/projects/page";
import ProjectDetail from "@/pages/projects/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import Notice from "@/pages/notice/page";
import NoticeDetail from "@/pages/notice/detail/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/brand",
        element: <Brand />,
      },
      {
        path: "/products",
        element: <Products />,
      },
      {
        path: "/products/:id",
        element: <ProductDetail />,
      },
      {
        path: "/projects",
        element: <Projects />,
      },
      {
        path: "/projects/:id",
        element: <ProjectDetail />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/notice",
        element: <Notice />,
      },
      {
        path: "/notice/:id",
        element: <NoticeDetail />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;